<svelte:options accessors />

<script lang="ts">
	import { getContext } from 'svelte'
	import { t } from '$lib/translations'
	import type { ActionResult } from '@sveltejs/kit'
	import type { Writable } from 'svelte/store'
	import ValidationMessage from './ValidationMessage.svelte'

	export let cls = ''
	export let inputCls = ''

	//Props
	export let testid: string | null = null
	export let name: string
	export let validationName = ''
	export let placeholder: string | null = null
	export let type = 'text'
	export let weight = 'font-semibold'
	export let formaction: string | null = null
	export let maxlength = 255
	export let readonly = false
	export let disabled = false
	export let validationMessage = true

	//Stores
	export let fail: Writable<Extract<ActionResult, { type: 'failure' }>> = getContext('fail')
	export let formData: Writable<Record<string, any>> = getContext('formData')

	//Classes
	export let textSize = 'text-sm'
	export let margin = 'my-3'
	export let theme: 'white' | 'dark' = 'white'
	let themeClasses = {
		white: {
			label: 'text-neutral-500'
		},
		dark: {
			label: 'text-left text-white'
		}
	}

	//Functions
	export function focus() {
		inputThis.focus()
		inputThis.select()
	}

	export function fill(val: string) {
		$formData[name] = inputThis.value = val
	}

	function typeAction(node: HTMLInputElement) {
		if (!['checkbox', 'radio'].includes(type)) node.type = type
	}

	let inputThis: HTMLInputElement

	$: valName = validationName || name
	$: failure = valName && $fail?.data?.[valName]
</script>

<label class="{cls} {margin} {textSize} {themeClasses[theme].label} relative mx-auto block w-full">
	{#if $$slots.default}
		<span class="mb-1 block text-sm {weight}">
			<slot />
		</span>
	{/if}
	<div class="relative flex gap-2">
		<input
			data-testid={testid}
			class="{textSize} autofill-none w-full appearance-none rounded-md border-2 border-neutral-300 bg-white px-[10px] py-[15px] text-lg text-neutral-800 shadow-sm !outline-none !ring-0 transition-colors duration-500
      {inputCls}"
			use:typeAction
			{name}
			{placeholder}
			{maxlength}
			{readonly}
			{disabled}
			class:border-primary-500={failure}
			bind:this={inputThis}
			bind:value={$formData[name]}
			on:paste
			on:input
			on:click
			on:keyup
			on:keydown
			on:change={() => {
				if ($fail?.data && valName && failure) $fail.data[valName] = ''
			}}
		/>
		{#if formaction}
			<button {formaction} class="absolute right-[15px] top-1/2 translate-y-[-50%] text-primary-500"
				>{t('web.forms.change')}</button
			>
		{/if}
	</div>
	{#if name && validationMessage}
		<ValidationMessage {name} />
	{/if}
</label>

<style>
	input:read-only:focus {
		cursor: default;
		border-color: theme('colors.neutral.300');
	}

	input:focus:not(:read-only) {
		border-color: theme('colors.neutral.500');
	}
</style>
